const dotenvVars = require('dotenv-flow').config({
  node_env: process.env.APP_ENV,
  default_node_env: 'development'
}).parsed;

const packageJson = require('../package.json');

const BAKED_IN_ENV_VARS = [
  'NODE_ENV',
  'PUBLIC_URL',
  'VERSION',
  'OLD_RAILS_SEO_BASE_URL',
  'UTM_SOURCE',
  'STATIC_PAGE_URL',
  'STATIC_PATH_PREFIX',
  'MWEB_URL'
];

function getAppEnv() {
  const raw = Object.keys(dotenvVars || {}).reduce(
    (env, key) => {
      env[key] = process.env[key];
      return env;
    },
    {
      NODE_ENV: process.env.NODE_ENV,
      PUBLIC_URL: process.env.PUBLIC_URL,
      VERSION: packageJson.version,
      UTM_SOURCE: process.env.UTM_SOURCE,
      STATIC_PAGE_URL: process.env.STATIC_PAGE_URL,
      STATIC_PATH_PREFIX: process.env.STATIC_PATH_PREFIX,
      MWEB_URL: process.env.MWEB_URL
    }
  );

  const forWebpackDefinePlugin = {
    'process.env': Object.keys(raw).reduce((env, key) => {
      if (BAKED_IN_ENV_VARS.includes(key)) {
        env[key] = JSON.stringify(raw[key]);
      }
      return env;
    }, {})
  };

  const forIndexHtml = JSON.stringify({
    env: raw
  });

  return { raw, forIndexHtml, forWebpackDefinePlugin };
}

module.exports = {
  getAppEnv
};
